import { useEffect, useMemo, useRef, useState } from "react"
import { unstable_batchedUpdates } from "react-dom"
import { iFile } from "../definitions/File"
import { get } from "../store/data/actions"

interface iProps {
  fileId?: string
  fileCollection: string
}

export function useImage({ fileId, fileCollection }: iProps) {
  const [file, setFile] = useState<iFile>()
  const [loading, setLoading] = useState(true)
  // eslint-disable-next-line @typescript-eslint/no-unused-vars, no-unused-vars
  const [pingForFile, setPing] = useState(false)
  const _interval = useRef<NodeJS.Timeout>()
  const _shouldPing = useRef(false)
  const _pingTime = useRef(5000)
  useMemo(() => {
    if (fileId) {
      setLoading(true)
      get<iFile>({
        link: "/v1/file",
        query: { collection: fileCollection, _id: fileId },
      }).then(({ versions, ...rest }) => {
        unstable_batchedUpdates(() => {
          setLoading(false)
          setFile({ versions, ...rest, _id: fileId })
        })
      })
    }
  }, [fileId])

  useEffect(() => {
    _shouldPing.current = pingForFile

    const intervalFunction = () => {
      if (fileId) {
        get<iFile>({
          link: "/v1/file/",
          query: { collection: fileCollection, _id: fileId },
        }).then(({ versions, ...rest }) => {
          setFile({ versions, ...rest, _id: fileId })
          _interval.current && clearInterval(_interval.current)
          if (_shouldPing.current) {
            _pingTime.current *= 2
            _interval.current = setInterval(intervalFunction, _pingTime.current)
          }
        })
      }
    }

    if (_shouldPing.current) {
      if (_interval.current) return
      _interval.current = setInterval(intervalFunction, _pingTime.current)
    } else {
      _interval.current && clearInterval(_interval.current)
    }
  }, [pingForFile])

  return { file, loading }
}
